import React, { useEffect, useState } from 'react';

import { formatMinutesToHoursString } from '@src/packages/utils/functions';

import { getUserArrivalDelayMinutes } from '../../utils/attendanceStatus/resolveAttendanceStatus';

const DELAY_TICK_MS = 60_000;

export interface WorkJourneyArrivalDelayCellProps {
  scheduledStartAtSeconds: number | null;
  actualStartAtSeconds: number | null;
}

const WorkJourneyArrivalDelayCell: React.FC<WorkJourneyArrivalDelayCellProps> = ({
  scheduledStartAtSeconds,
  actualStartAtSeconds,
}) => {
  const [now, setNow] = useState(() => new Date());
  const isUnmarked = actualStartAtSeconds === null;

  useEffect(() => {
    if (!isUnmarked) {
      return undefined;
    }

    const intervalId = window.setInterval(() => setNow(new Date()), DELAY_TICK_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isUnmarked]);

  const delayMinutes = getUserArrivalDelayMinutes({
    scheduledStartAtSeconds,
    scheduledEndAtSeconds: null,
    actualStartAtSeconds,
    actualEndAtSeconds: null,
    toleranceTimeMinutes: 0,
    leaveType: null,
    now,
  });

  return <>{delayMinutes === null ? '—' : formatMinutesToHoursString(delayMinutes)}</>;
};

export default React.memo(WorkJourneyArrivalDelayCell);
